import { useState } from "react";

import './Password.css';

import { Svg_Eye, Svg_EyeClose } from "../../Svg";

import { SetStatusGlobal } from "../../../interface/Global";

interface Props {
    title: string;
    value: string;
    setValue: ((value: string) => void) | ((input: string, index: number, value: string) => void);
    input?: string;
    index?: number;
    required?: boolean;
    maxLength?: number;
    placeholder?: string;
    recover?: boolean;
    setStage?: React.Dispatch<React.SetStateAction<number>>;
}

export default function Comp_Password(props: Props) {

    const [ typeInput, setTypeInput ] = useState<'password' | 'text'>('password');
    const [ isFocused, setIsFocused ] = useState(false);

    function ShowHidePass() {
        setTypeInput(typeInput === "text" ? "password" : "text");
    }

    function ReturnInput(value: string) {
        if (props.index !== undefined) {
            (props.setValue as (input: string, index: number, value: string) => void)(props.input!, props.index, value);
        } else {
            (props.setValue as (value: string) => void)(value);
        }
    }

    return (
        <div className="Comp_Password">
            <div className={ isFocused ? "name_input name_focus" : "name_input" }>
                { props.title }
            </div>

            <input
                type={ typeInput }
                onChange={ (e) => { ReturnInput(e.target.value) } }
                value={ props.value }
                required={ props.required ?? false }
                maxLength={ props.maxLength }
                placeholder={ props.placeholder ?? "" }
                onFocus={ () => { setIsFocused(true) } }
                onBlur={ () => { setIsFocused(false) } }
            />
            <div className="div_eye" onClick={ () => { ShowHidePass() } }>
                {
                    typeInput === "text"
                        ? <Svg_Eye className="icons" color="#737574" />
                        : <Svg_EyeClose className="icons" color="#737574" />
                }
            </div>
            {
                props.recover ? 
                    <div className="recover" onClick={ () => { SetStatusGlobal('recover_access', true); props.setStage?.(1); } }>Forgot your password?</div>
                : null
            }
        </div>
    );
}
